module.exports = __webpack_public_path__ + "img/9788927805908.1df53fb3.jpg";